<template>
  <div id="app">
    <router-view></router-view>
    <div class="line-scale" v-show="isLoading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  components: {},
  methods: {},
  created: function() {},
  computed: {
    ...mapGetters('fortune', {
      isLoading: 'isLoading'
    })
  }
}
</script>

<style></style>
